module.exports = "https://static.wmbcdn.com/uniweb/images/78a1715d12b10558924a6753a2f5b061.svg";